// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"ba5567db","524":"97692faf","568":"80c7cadc","640":"9f946311","689":"5614c784","942":"8128e322"}[chunkId] + ".chunk.css";
};